import Vue from 'vue'
import VueI18n from "vue-i18n";

let instance = undefined;

const core = {
    i18n() {
        if (instance !== undefined) {
            return instance;
        }

        Vue.use(VueI18n);
        window.findologic = window.findologic || {};

        const
            option = { locale: '', messages: {}},
            conf = window.findologic.i18n || option;

        option.locale = conf.locale;
        option.messages[conf.locale] = Object.assign({}, conf.messages);

        return instance = new VueI18n(option)
    }
}

export default core.i18n();
